<script setup lang="ts">
import {HospitalPatientFile} from "@/core/interfaces/hospital/HospitalPatientFile";
import dateHelper from "../../../core/helpers/dateHelper";
import {hospitalFileApi} from "@/container";

const props = defineProps<{
    file: HospitalPatientFile
}>();

/**
 * Download and open the file.
 */
const open = () => {
    hospitalFileApi().download(props.file)
        .then((blob) => {
            const url = URL.createObjectURL(blob);
            window.open(url);
        });
};
</script>

<template>
  <div class="p-2 cursor-pointer" @click="open">
    <p class="hover:underline">
      {{ file.type.name }} du {{ dateHelper.shortFormat(file.created_at) }}
    </p>
  </div>
</template>

<style scoped>

</style>
